import React, { type ReactNode } from 'react';

import { HorizontalBox } from './Box';
import { Typography, useScreenSize, useSafeArea } from '@banhala/ui-kit';
import { isAndroid, isNotNil } from 'shared/src/utils';

interface PastelToastProps {
  message: string | ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: any;
}
const PastelToast = ({ message, props: { customText } }: PastelToastProps) => {
  // const size = useScreenSize();
  const size = useScreenSize();
  const padding = 12 * 2;
  const width = size.width > 600 ? 600 : size.width;
  const { bottom } = useSafeArea();

  if (isNotNil(customText))
    return (
      <HorizontalBox
        margin={{ horizontal: 12 }}
        padding={{ horizontal: 12 }}
        backgroundColor={'black'}
        borderRadius={8}
        backgroundColorOpacity={0.8}
        bottom={isAndroid ? bottom : undefined}
      >
        {customText}
      </HorizontalBox>
    );

  return (
    <HorizontalBox
      padding={{ vertical: 8, horizontal: 14 }}
      width="100%"
      maxWidth={width - padding}
      backgroundColorOpacity={0.8}
      bottom={isAndroid ? bottom : undefined}
      borderRadius={8}
      backgroundColor={'black'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      {typeof message === 'string' ? (
        <Typography type="body1" color="content_always_white">
          {message}
        </Typography>
      ) : (
        <>{customText}</>
      )}
    </HorizontalBox>
  );
};

export default PastelToast;
